(function () {
  function mount(root) {
    if (!root || root.dataset.footerMounted === 'true') return;
    root.dataset.footerMounted = 'true';
    const items = [...root.querySelectorAll('.ms-footer-item')];
    items.forEach((item, index) => {
      const panel = item.querySelector('.ms-footer-flyout');
      const link = item.querySelector(':scope > .ms-footer-heading, :scope > a');
      if (!panel || !link) return;
      item.classList.add('ms-footer-expandable');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ms-footer-disclosure';
      button.textContent = link.textContent.trim();
      panel.id = (root.closest('[id]')?.id || 'footer') + '-links-' + index;
      button.setAttribute('aria-controls', panel.id);
      button.setAttribute('aria-expanded', 'false');
      link.after(button);
      button.addEventListener('click', () => {
        const open = !item.classList.contains('is-open');
        items.forEach(other => {
          other.classList.remove('is-open');
          other.querySelector('.ms-footer-disclosure')?.setAttribute('aria-expanded', 'false');
        });
        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
      });
    });
  }
  function mountAll() { document.querySelectorAll('[data-ms-footer]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
})();
